import { useState } from "react";
import { NavProps } from "./data";
import { NavLink } from "react-router-dom";
import { ReactComponent as Arrow } from "../../../svgs/arrow-right.svg";
import styles from "./sidebar.module.scss";

const activeStyle = {
  display: "flex",
  gap: "0.875rem",
  alignItems: "center",
  textDecoration: "none",
  fontWeight: 500,
  padding: "1rem",
  backgroundColor: "var(--color-nav-hover-bg)",
  borderRadius: "5px",
};

const dropdownActiveStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  textDecoration: "none",
  fontWeight: 500,
  padding: "1rem",
  color: "var(--color-grey-black)",
  backgroundColor: "var(--color-nav-hover-bg)",
  borderRadius: "5px",
};

const SubMenu: React.FC<NavProps> = ({ title, path, icon, subNav }) => {
  const [sub, setSub] = useState(false);
  const showSub = () => setSub((prev) => !prev);

  return (
    <>
      {path ? (
        <NavLink
          style={({ isActive }) => (isActive ? activeStyle : {})}
          className={styles.navLink}
          to={path}
        >
          {icon}
          <span>{title}</span>
        </NavLink>
      ) : (
        <div className={styles.navButton} onClick={subNav && showSub}>
          <div className={styles.wrapper}>
            {icon}
            <span>{title}</span>
          </div>
        </div>
      )}
      
      {sub && (
        <section className={styles.dropdownNavWrapper}>
          <div className={styles.line}></div>
          <div style={{ width: "100%" }}>
            {subNav?.map((item, index) => (
              <NavLink
                key={index}
                style={({ isActive }) => (isActive ? dropdownActiveStyle : {})}
                className={styles.dropdownNavLink}
                to={item.path}
              >
                {item.title}{" "}
                <span>
                  <Arrow />
                </span>
              </NavLink>
            ))}
          </div>
        </section>
      )}
    </>
  );
};

export default SubMenu;
